import { render, staticRenderFns } from "./w-slider.vue?vue&type=template&id=8997aaa0&lang=pug&"
import script from "./w-slider.vue?vue&type=script&lang=js&"
export * from "./w-slider.vue?vue&type=script&lang=js&"
import style0 from "./w-slider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8997aaa0')) {
      api.createRecord('8997aaa0', component.options)
    } else {
      api.reload('8997aaa0', component.options)
    }
    module.hot.accept("./w-slider.vue?vue&type=template&id=8997aaa0&lang=pug&", function () {
      api.rerender('8997aaa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/widgets/w-slider.vue"
export default component.exports